import React from 'react'
import PropTypes from 'prop-types'

const AppMainContainer = ({ children }) => (
  <div className="app-main-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
    <img className="main-logo" src="/vendors/lingoowl/owl.png" width={150} alt="lingoowl logotype" title="LingoOwl logotype"/>
    <div className="app-signup">
      {children}
      <a href='http://lingoowl.com'  style={{float: 'right'}}><img src="/vendors/lingoowl/lingoowl-logo.png" width={100} alt="LingoOwl logotype" title="lingoowl logotype"/></a>
    </div>
  </div>
)

AppMainContainer.propTypes = {
  children: PropTypes.node
}

export default AppMainContainer



// WEBPACK FOOTER //
// ./Linkgua/containers/AppMainContainer.js